var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"c-product-variants-table__teaser"},[_c('button',{staticClass:"btn btn-outline-primary c-product-variants-table__teaser--button bg-white",on:{"click":_vm.showHiddenVariants}},[_c('i',{staticClass:"far fa-arrow-down mr-2"}),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.getProductPageTranslations[
              'ProductDetail.VariantsTable.TeaserButton.ShowAll'
            ])+"\n          "+_vm._s(_vm.productCount)+"\n          "+_vm._s(_vm.getProductPageTranslations[
              'ProductDetail.VariantsTable.TeaserButton.Products'
            ])+"\n        ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }